import React from "react";
import { Radio, Select } from "antd";
import { PRODUCT, RESTAURANT } from "./bannerLink";
import { useRestaurantProducts, useRestaurants } from "./linkOptions";

const byName = (input, option) => option.label.toLowerCase().includes(input.trim().toLowerCase());

const optionsWith = (rows, current) => {
  const options = rows.map((row) => ({ value: row.id, label: row.name }));
  return current && !options.some((option) => option.value === current.id)
    ? [{ value: current.id, label: current.name }, ...options]
    : options;
};

function SearchSelect({ placeholder, rows, current, onPick }) {
  return (
    <Select
      className="mt-2"
      style={{ width: "100%" }}
      showSearch
      placeholder={placeholder}
      aria-label={placeholder}
      value={current ? current.id : undefined}
      options={optionsWith(rows, current)}
      filterOption={byName}
      notFoundContent="Nothing matches"
      onChange={(id, option) => onPick({ id, name: option.label })}
    />
  );
}

export default function LinkPicker({ open, franchiseId, value, onChange }) {
  const { type, restaurant, product } = value;
  const restaurants = useRestaurants(open, franchiseId);
  const products = useRestaurantProducts(open && type === PRODUCT && restaurant ? restaurant.id : null);

  return (
    <>
      <label className="d-block mt-3 mb-1">Opens</label>
      <Radio.Group value={type} onChange={(e) => onChange({ ...value, type: e.target.value, product: null })}>
        <Radio value={PRODUCT}>Product</Radio>
        <Radio value={RESTAURANT}>Restaurant</Radio>
      </Radio.Group>
      <SearchSelect
        placeholder="Search a restaurant"
        rows={restaurants}
        current={restaurant}
        onPick={(picked) => onChange({ type, restaurant: picked, product: null })}
      />
      {type === PRODUCT && restaurant && (
        <SearchSelect
          placeholder={`Search a product of ${restaurant.name}`}
          rows={products}
          current={product}
          onPick={(picked) => onChange({ ...value, product: picked })}
        />
      )}
    </>
  );
}
